
// export const useUser = () => useContext(UserContext);
import { createContext, useContext, useState, useEffect } from "react";
const UserContext = createContext();


export const UserProvider = ({ children }) => {
  const [userID, setUserID] = useState(null);

  useEffect(() => {
    const storedId = localStorage.getItem("a13b_c9z_uid");
    setUserID(storedId);
  }, []);

  const login = (id) => {
    localStorage.setItem("a13b_c9z_uid", id);
    setUserID(id);
  };

  const logout = () => {
    localStorage.removeItem("a13b_c9z_uid");
    localStorage.removeItem("bingold");
    localStorage.removeItem("device_id");
    setUserID(null);
  };

  return (
    <UserContext.Provider value={{ userID, setUserID, login, logout }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
